// @flow

import React from 'react';

import NoSSR from 'web-ssr/browser/components/NoSSR';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { PolicyPendingCheck } from '@zapier/design-system-patterns';
import { isBrowser } from '@zapier/common-utils';

import useCurrentUser from 'web-ssr/app/common/hooks/useCurrentUser';

const stripPathSlashes = pathname => pathname.replace(/^\/+|\/+$/gm, '');
const getCurrentPathname = () =>
  stripPathSlashes(isBrowser() ? window.location.pathname : '');

// When the user is on these routes, the policy modal should not be visible.
const policyModalHiddenRoutes = ['legal', 'tos', 'tou', 'aup', 'privacy'];

const CheckPendingPolicies = () => {
  const { isAuthenticated, isMasquerade } = useCurrentUser();
  const currentPath = getCurrentPathname();

  // Logged-in users will be presented with the policy modal until they
  // accept it. If they want to navigate to the new policy updates, we should
  // allow them to do so without the modal being presented (and therefore
  // blocking their view).
  if (policyModalHiddenRoutes.includes(currentPath)) {
    return null;
  }

  // Show only for logged-in users and do not show for users which are
  // masquerading.
  if (!isAuthenticated || isMasquerade) {
    return null;
  }

  return (
    <PolicyPendingCheck
      currentPathname={currentPath}
      useMutation={useMutation}
      useQuery={useQuery}
      useTrackingContext={useTrackingContext}
    />
  );
};

const CheckPendingPoliciesClient = () => (
  <NoSSR>
    <CheckPendingPolicies />
  </NoSSR>
);

export default CheckPendingPoliciesClient;
